import { ReactNode } from "react";
import { Button, Icon } from "@sellar-io/components";
import { IconType } from "@sellar-io/components";
import { Dialog, DialogNavigation, DialogContent, DialogCTA } from "./Dialog";

interface BasicDialogProps {
  title?: string;
  description?: string;
  loading?: boolean;
  dialogActive: boolean;
  children?: ReactNode;
  onConfirm?: () => void;
  onDelete?: () => void;
  onDismiss?: () => void;
  confirmFormId?: string;
  confirmButtonText?: string;
  dismissButtonText?: string;
  deleteButtonText?: string;
  deleteLabel?: string;
  icon?: keyof typeof IconType;
  iconColor?: string;
}

export const BasicDialog = ({
  title,
  description,
  loading,
  dialogActive,
  children,
  onConfirm,
  onDelete,
  onDismiss,
  confirmFormId,
  confirmButtonText = "confirm",
  deleteButtonText = "delete",
  icon,
  iconColor,
}: BasicDialogProps) => {
  const getIconColor = () => {
    if (iconColor) return iconColor;

    switch (icon) {
      case "ALERT_CIRCLE_OUTLINE":
        return "#FF9066";
      case "DOWNLOAD":
        return "#96DDE2";
      default:
        return undefined;
    }
  };

  return (
    <Dialog active={dialogActive} onDismiss={() => onDismiss?.()}>
      <DialogNavigation
        title={title}
        description={description}
        leftIcon={onDismiss ? "CHEVRON_DOWN" : undefined}
        onClickLeftIcon={loading ? () => {} : onDismiss}
      >
        {!!icon && (
          <Icon
            className={"m-auto py-2"}
            size={4}
            icon={icon}
            color={getIconColor()}
          />
        )}
      </DialogNavigation>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogCTA>
        {onDelete && (
          <Button color={"red"} onClick={onDelete} loading={loading}>
            {deleteButtonText}
          </Button>
        )}

        {(onConfirm || confirmFormId) && (
          <Button
            type={confirmFormId ? "submit" : "button"}
            form={confirmFormId}
            onClick={() => onConfirm?.()}
            loading={loading}
          >
            {confirmButtonText}
          </Button>
        )}
      </DialogCTA>
    </Dialog>
  );
};
